import { render, staticRenderFns } from "./wyRaceDan.vue?vue&type=template&id=9bd920e8&scoped=true"
import script from "./wyRaceDan.vue?vue&type=script&lang=js"
export * from "./wyRaceDan.vue?vue&type=script&lang=js"
import style0 from "./wyRaceDan.vue?vue&type=style&index=0&id=9bd920e8&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9bd920e8",
  null
  
)

export default component.exports